export default __webpack_public_path__ + "static/media/icon-default-kitten.f870853e.svg";